import { Search } from "lucide-react";
import { NotFoundState, stateButton } from "@/components/patterns";
import { usePalette } from "@/components/shell/CommandPalette";

/** Any address the app doesn't know, shown inside the app frame */
export function NotFoundPage() {
  const palette = usePalette();
  return (
    <NotFoundState>
      <button type="button" onClick={() => palette.setOpen(true)} className={`${stateButton.dark} gap-1.5`}>
        <Search className="size-3.5" />
        Search leads, deals, people
      </button>
    </NotFoundState>
  );
}
